export const Config = {
    apiUrl: 'https://apisurcap.fiere-allure.fr',
    appUrl: 'https://surcap.fiere-allure.fr',
};
